var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-nav'),_c('div',{staticClass:"main-layout"},[_c('router-view',{staticClass:"main"})],1),_c('the-modal'),_c('the-loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }